module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_vm._v("Chapter Eight")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_vm._v("I awakened in flight.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I was not in a tarn basket, nor tied in the shambles of one as I had been last night.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("The remains of the tarn basket had been discarded.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I lay on my back, stretched over a broad convex sheet of leather which was part of the saddle. My hands were chained back, over my head, to a ring, and my ankles were chained, as well, to another ring.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I was naked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("Happily I was not hooded.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I could see little of the tarn, but there was no mistaking the large, broad wings which, stroke by stroke, sped us through the air.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("The reins of the tarn, a set of straps ran over my belly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“It is time you awakened, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kajira")]), _vm._v(",” he said. “I trust you slept well. I trust you have recovered from your indisposition of yesterday evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Yes, Master,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“What was wrong?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("Suddenly my fear again swept over me. I began to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Are you mad?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I do not want to die,” I wept.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“You are not unique,” he said. “Few regard that prospect with zest. What is wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“They want to kill me,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Who?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Those to whom you are to deliver me,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“How do you know?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“It must be,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("What could he know of secret wars, of intrigues which might be both subtle and vast? How could I speak to him of depths which I myself could not fathom?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Please, please do not give me over to those who await me,” I begged.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Do you bargain?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“No, Master,” I said. Could a dog bargain with her Master? I was not a free woman. I had nothing with which to bargain. I did not even own my own collar. I could not dangle my favors tantalizingly before him. Already I lay before him, naked and chained, his to do with as he might please.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“But you might plead?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Yes, yes, yes, Master!” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“What a slave wishes does not matter,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Yes, Master,” I wept.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("Who did not know that?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“You are very stupid,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“How so?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Or, more likely, you think me unbelievably stupid,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“No, Master,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Think,” he said. “It need not cause pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I do not understand,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I am not stupid,” he said. “I am shrewd, I am clever.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Yes, Master,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I was to pick you up for forty copper tarsks, a fee that attracts little attention,” he said. “But I suspected a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sleen")]), _vm._v(" in the vicinity. When you see the snout of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sleen")]), _vm._v(", the rest is not far behind. I gambled. I won. I extorted two silver tarsks. I was clever, I was shrewd. Do you think then I will deliver you somewhere for the paltry sum of another forty copper tarsks? I would be a fool to do so. I could sell you for more.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Master!” I sobbed suddenly, joyfully.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("He made some adjustment to the reins of the bird.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Then you have no intention of delivering me to the contracted party?” I said, the morning suddenly become bright.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“No,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“And Master’s trick,” I said, uneasily, “might not work twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“No,” he said. “Definitely not. It would not be favored by the odds. You would be in the vicinity, available for discovery, and seizure, and I would be within range of retaliation.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“And word of your brilliance, your economic coup, might even now be speeding from the camp of Master Philip to the point of delivery.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I think not,” he said. “Much here is secret. I do not think that Philip would know fully the point of delivery, the parties involved, or such things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Even so,” I said, “the delivery unmade, you have placed yourself at risk.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“It will be many days before it is even realized at the delivery point that the delivery is late, let alone that it will not be made. By then I could be anywhere, in the mountains of Thentis, in the Tahari, in the Barrens, in far Turia, even at the World’s End.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I am unutterably grateful,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“It will not be easy for you to be traced,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“My collar,” I said, “identifies me as the property of Bazi Imports, a collar supposedly rare this far north.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I have the key,” he said. “I will remove it and scrape away the legend. Such collars, defaced, re-lettered, and so on, are not rare, particularly amongst the Peasants.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I am marked with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kef")]), _vm._v(",” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Do not concern yourself,” he said. “It is the most common slave brand on Gor.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Master will sell me?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“As soon as possible,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I am content,” I said, happily.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I will cause the bird to veer,” he said. “Look then, as you can, below.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I was pleased to look forward to this, as I had seen little so far but clouds, and an occasional bird.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("Suddenly the bird shifted flight, and I gasped, but, swung in the chains and rings, I looked down, eagerly, to my left.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Those are ripening "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sa-tarna")]), _vm._v(" fields,” he said, “there, in the Vosk basin, south of the river. Some of the richest farmland on Gor lies in the Vosk basin. Look further and you can see the river, like a silver ribbon, in the distance. It seems narrow from here but it is a mighty river, often four or five "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pasangs")]), _vm._v(" in breadth. It drains most of a continent. It goes past dozens of towns and villages. It empties into the vast marshland of the delta, and, beyond, into the Tamber Gulf and then into Thassa, the sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“It is beautiful,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("At the moment I suspected that anything would look beautiful, even were it not as beautiful as the broad, lush golden fields below.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("Then the bird, guided by the reins, righted its flight, and I sank back over the heavy, convex sheet of leather over which I was chained. It struck me as I did so how my body, arched over the leather, was lifted before the controller of the bird, as though for his perusal or casual touch.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“This is a beautiful world,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“We intend to keep it that way,” he said, angrily.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I was startled. I wondered if he had ever been to my former world. Perhaps he had heard stories of its economic pillaging and the vile failures of the stewardship to which it had been subjected. What was one to make of creatures which fouled their own dens or nests? There was a saying on Gor that the females of Earth were fit only to be the slaves of men of Gor. But is it not always the case that the females of the enemy become the vulnerable, helpless slaves of the victors? And is not that as it should be? Women are properly slaves and loot. Let them understand themselves so. What woman does not know in her heart that she is the proper slave of a Master?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Oh!” I said, for I had been touched.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“I am going to prime you,” he said, “and bring you to the point of yielding, to the point where you beg to yield, and then I shall desist.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“No, Master!” I begged. “Do not do so! Please do not do so! Do not be cruel! Have mercy on a poor slave!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Do not concern yourself,” he said. “It will not last long. I would not even have begun had I not noted below that for which I have been searching.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("How could I not concern myself?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("For what had he been searching?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Do not begin what you will not finish,” I begged.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("“Be silent,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I twisted in the chains and rings.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("I whimpered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body- _idGenParaOverride-1"
  }, [_vm._v("I lay at his mercy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d54f658","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TreasuresOfGor_4P_SB-9.vue
// module id = 90
// module chunks = 0